<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      @if (duplicate) {
        <h1>{{'Duplicate holiday' | translate}}</h1>
      }
      @if (!duplicate) {
        @if (!holiday) {
          <h1>{{'Add holiday' | translate}}</h1>
        }
        @if (holiday) {
          <h1>{{'Edit holiday' | translate}}</h1>
        }
      }
      @if (error) {
        <div class="errorMessage">{{ error | translate}}</div>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <!-- <div class="L-12 M-12 S-12 columns" *ngIf="!project">
        <label>{{'Project' | translate}}**</label>
        <app-dropdown
          [(appModel)]="formData.project_id"
          [list]="projects"
          [value]="'id'"
          [name]="'title'"
          [multiple]="false"
        ></app-dropdown>
      </div> -->
      <div class="L-6 M-6 S-12 columns">
        <label>{{'Date' | translate}}**</label>
        <input type="date" name="date" [(ngModel)]="formData.date" placeholder="{{'Date' | translate}}" required>
      </div>
      <div class="L-6 M-6 S-12 columns">
        <label>{{'Country' | translate}}**</label>
        <app-dropdown
          [(appModel)]="formData.country_id"
          [list]="countries"
          [value]="'id'"
          [backTranslate]="true"
          [name]="'name'"
          [required]="true"
          [multiple]="false"
        ></app-dropdown>
      </div>
      <div class="L-12 M-12 S-12 columns">
        <label>{{'Description' | translate}}</label>
        <input type="text" name="description" [(ngModel)]="formData.description" placeholder="{{'Insert text' | translate}}">
      </div>
      <div class="L-12 M-12 S-12 columns">
        <div class="checkBoxCOnt">
          <input type="checkbox" name="all_years" [(ngModel)]="formData.all_years">
          <p class="checkbox">{{'All years' | translate | uppercase}}</p>
        </div>
      </div>
      <div class="L-12 M-12 S-12 columns TextCentered">
        <input name="sumbit" type="submit" value="{{'Save' | translate}}"  [disabled]="form.invalid">
      </div>
      <div class="L-12 M-12 S-12 columns TextCentered">
        <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
      </div>
    </form>
  </div>
}
</div>